import { initialize } from "@ionic/core/components";
import { IonApp } from "@ionic/core/components/ion-app";
import { IonHeader } from "@ionic/core/components/ion-header";
import { IonToolbar } from "@ionic/core/components/ion-toolbar";
import { IonButton } from "@ionic/core/components/ion-button";
import { IonContent } from "@ionic/core/components/ion-content";
import { IonAlert } from "@ionic/core/components/ion-alert";
import { IonTitle } from "@ionic/core/components/ion-title";
import { IonInput } from "@ionic/core/components/ion-input";
import { IonItem } from "@ionic/core/components/ion-item";
import { IonLabel } from "@ionic/core/components/ion-label";
import { IonGrid } from "@ionic/core/components/ion-grid";
import { IonRow } from "@ionic/core/components/ion-row";
import { IonCol } from "@ionic/core/components/ion-col";
import { IonCard } from "@ionic/core/components/ion-card";
import { IonCardHeader } from "@ionic/core/components/ion-card-header";
import { IonCardSubtitle } from "@ionic/core/components/ion-card-subtitle";
import { IonCardTitle } from "@ionic/core/components/ion-card-title";
import { IonSelect } from "@ionic/core/components/ion-select";
import { IonSelectOption } from "@ionic/core/components/ion-select-option";
import { IonItemOption } from "@ionic/core/components/ion-item-option";
import { IonFooter } from "@ionic/core/components/ion-footer";
import { IonButtons } from "@ionic/core/components/ion-buttons";
import { IonActionSheet } from "@ionic/core/components/ion-action-sheet";
import { IonSpinner } from "@ionic/core/components/ion-spinner";
import { IonProgressBar } from "@ionic/core/components/ion-progress-bar";

initialize();

customElements.define("ion-app", IonApp);
customElements.define("ion-header", IonHeader);
customElements.define("ion-content", IonContent);
customElements.define("ion-alert", IonAlert);
customElements.define("ion-button", IonButton);
customElements.define("ion-toolbar", IonToolbar);
customElements.define("ion-title", IonTitle);
customElements.define("ion-input", IonInput);
customElements.define("ion-label", IonLabel);
customElements.define("ion-item", IonItem);
customElements.define("ion-grid", IonGrid);
customElements.define("ion-row", IonRow);
customElements.define("ion-col", IonCol);
customElements.define("ion-card", IonCard);
customElements.define("ion-card-header", IonCardHeader);
customElements.define("ion-card-subtitle", IonCardSubtitle);
customElements.define("ion-card-title", IonCardTitle);
customElements.define("ion-select", IonSelect);
customElements.define("ion-select-option", IonSelectOption);
customElements.define("ion-footer", IonFooter);
customElements.define("ion-buttons", IonButtons);
customElements.define("ion-action-sheet", IonActionSheet);
customElements.define("ion-item-option", IonItemOption);
customElements.define("ion-spinner", IonSpinner);
customElements.define("ion-progress-bar", IonProgressBar);

import "@ionic/core/css/core.css";